import React from "react";
import DailyQuote from "../components/DailyQuote";
import DailyPhoto from "../components/DailyPhoto";
import styles from "./Home.module.css";

function Home() {
  return (
    <div className={styles["home-page"]}>
      <header className={styles["home-header"]}>
        <h1>Welcome to The Rhatigan Family Album!</h1>
        <p>A place to share and remember our favorite moments.</p>
      </header>

      <section className={styles["home-section"]}>
        <h2>Photo of the Day</h2>
        <DailyPhoto />
      </section>

      <section className={styles["home-section"]}>
        <h2>Quote of the Day</h2>
        <DailyQuote />
      </section>
    </div>
  );
}

export default Home;
